const contractBaseURL = '/services/plugin-attributes-manager'

export const UNITS = `${contractBaseURL}/contracts/units`
export const COST_TYPES = `${contractBaseURL}/contracts/items/costTypes`
export const WELLS = `${contractBaseURL}/wells`
export const RIGS = `${contractBaseURL}/rigs`
export const NODES = `${contractBaseURL}/nodes`
